package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.width
import io.horion.cv.components.widgets.RichTextDescription
import io.horion.cv.models.DescriptionState
import org.jetbrains.compose.web.css.px

@Composable
fun DescriptionForm(
    state: DescriptionState,
    onDescriptionChange: (String) -> Unit
) {
    Column(
        modifier = Modifier.fillMaxWidth(),
        verticalArrangement = Arrangement.spacedBy(10.px)
    ) {
        RichTextDescription(
            label = "Description",
            value = state.description,
            onValueChange = onDescriptionChange,
            modifier = Modifier.fillMaxWidth()
        )
    }
}